/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { cards } from '../helpers/api';
import { Tabs, MonetaryTable } from '../components';
import { Button as ButtonLib } from '../elements';
import Spinner from '../elements/Spinner';
import dashboardColors from '../helpers/dashboardColors';
import devices from '../styles/devices';

const Container = styled.div`
  max-width: 750px;
  margin: 0 auto;
`;
const LastTransactions = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.gray400};
`;
const Button = styled(ButtonLib)`
  color: ${({ theme, type }) => dashboardColors(theme, type).color1} !important;
  border-color: ${({ theme, type }) =>
    dashboardColors(theme, type).color1} !important;
`;
const ViewMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;
  &.only-desktop {
    @media (max-width: ${devices.tablet}) {
      display: none;
    }
  }
`;

const EmptyMsg = styled.p`
  text-align: center;
  padding: 40px 0;
  font-size: 1.4em;
`;

const Loading = () => (
  <div style={{ textAlign: 'center' }}>
    <Spinner />
  </div>
);

const emptyMsg = '🙁 Você ainda não tem lançamentos no período';

// eslint-disable-next-line react/prop-types
const Table = ({ data, card, isLoading, isTotal, viewMore, mobile }) => (
  <MonetaryTable data={data} mobile={mobile}>
    <ViewMoreContainer className={`${!mobile ? 'only-desktop' : ''}`}>
      {isLoading ? (
        <Spinner size={60} />
      ) : (
        !isTotal && (
          <Button
            // eslint-disable-next-line react/prop-types
            color={card.codigoProduto}
            variant="outlined"
            label="Ver mais lançamentos"
            onClick={viewMore}
          />
        )
      )}
    </ViewMoreContainer>
  </MonetaryTable>
);

const TransactionsTable = ({ card }) => {
  const [transactions, setTransactions] = useState();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  const getTransactions = useCallback(
    page =>
      cards.provisionalTransactions(
        card.numberCard,
        page, // page
        20, // items per page
      ),
    [card],
  );

  useEffect(() => {
    setLoading(true);
    setPage(0);
    getTransactions(page)
      .then(response => {
        if (!response.result) {
          throw new Error('no-content');
        }
        setTransactions(response.result);
        setTotalPages(response.pagination?.totalPages);
      })
      .catch(e => {
        setTransactions(e.message === 'no-content' ? emptyMsg : false);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, [card]);

  useEffect(() => {
    if (page > 0) {
      setLoading(true);
      getTransactions(page)
        .then(response => {
          if (!response.result) {
            throw new Error('no-content');
          }
          const prevValue = transactions || [];
          setTransactions([...prevValue, ...response.result]);
          setTotalPages(response.pagination?.totalPages);
        })
        .catch(e => {
          setTransactions(e.message === 'no-content' ? emptyMsg : false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [page]);

  return (
    <>
      <Tabs
        type={card.codigoProduto}
        title="extrato"
        data={[
          {
            id: 0,
            content: Array.isArray(transactions) ? (
              <Table
                data={transactions}
                card={card}
                isTotal={page >= totalPages - 1}
                viewMore={() => setPage(page + 1)}
                isLoading={loading}
              />
            ) : typeof transactions === 'string' ? (
              <EmptyMsg>{transactions}</EmptyMsg>
            ) : transactions === undefined ? (
              <Loading />
            ) : (
              'Erro ao capturar transações'
            ),
          },
        ]}
        component={<LastTransactions>Últimas transações</LastTransactions>}
      />
    </>
  );
};

TransactionsTable.propTypes = {
  card: PropTypes.object,
};

export default function ProvisionalTransactions({ card, isSlideActive }) {
  return (
    <Container data-testid="Transações">
      <TransactionsTable card={card} isSlideActive={isSlideActive} />
    </Container>
  );
}

ProvisionalTransactions.propTypes = {
  card: PropTypes.object,
  isSlideActive: PropTypes.bool,
};
